module.exports = __webpack_public_path__ + "static/media/E10.b72cd610.png";